import React from 'react';
import { Card } from '../../components/ui/Card';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Package, Clock, MessageSquare, AlertTriangle, Check, ChevronDown, Search } from 'lucide-react';
const ORDER_TABS = [{
  label: 'Live Queue',
  path: ''
}, {
  label: 'Flagged (3)',
  path: 'flagged'
}, {
  label: 'Order History',
  path: 'history'
}, {
  label: 'Analytics',
  path: 'analytics'
}];
const STATIONS = [{
  name: 'Burgeri',
  load: 72,
  color: 'bg-rose-400',
  icon: '🍔'
}, {
  name: 'Palačinke',
  load: 45,
  color: 'bg-green-400',
  icon: '🥞'
}, {
  name: 'Pakovanje',
  load: 38,
  color: 'bg-purple-400',
  icon: '📦'
}, {
  name: 'Giros',
  load: 88,
  color: 'bg-teal-400',
  icon: '🌯',
  warning: true
}];
const ORDERS = {
  new: [{
    id: '#4521',
    channel: 'Wolt',
    location: 'Vračar',
    time: '14:32',
    items: ['2x Double Smash', '1x Pomfrit'],
    stations: ['Burgeri', 'Pack'],
    est: '11 min',
    comment: 'No onions pls'
  }, {
    id: '#4520',
    channel: 'Wolt',
    location: 'Vračar',
    time: '14:30',
    items: ['1x Triple Smash', '2x Pepsi'],
    stations: ['Burgeri'],
    est: '9 min'
  }, {
    id: '#4519',
    channel: 'Collina.rs',
    location: 'Vračar',
    time: '14:28',
    items: ['3x Palačinka Nutela', '1x Američka'],
    stations: ['Palačinke'],
    est: '7 min',
    comment: 'Extra whipped'
  }],
  progress: [{
    id: '#4518',
    channel: 'Wolt',
    location: 'Vračar',
    time: '14:25',
    items: ['1x BIG Double', '1x Palačinka'],
    stations: ['Multi-station'],
    actual: '5:30',
    est: '9 min',
    status: 'good'
  }, {
    id: '#4517',
    channel: 'Wolt',
    location: 'Vračar',
    time: '14:22',
    items: ['2x Giros', '1x Salata'],
    stations: ['Giros+Salate'],
    actual: '8:45',
    est: '10 min',
    status: 'warning'
  }, {
    id: '#4516',
    channel: 'Wolt',
    location: 'BB',
    time: '14:18',
    items: ['1x Combo 2x burger', '2x Palačinke'],
    stations: ['Multi-station'],
    actual: '12:20',
    est: '8 min',
    status: 'critical'
  }],
  ready: [{
    id: '#4515',
    channel: 'Wolt',
    location: 'Vračar',
    done: '8:45',
    est: '9 min',
    estAccurate: true,
    wait: '2:30'
  }, {
    id: '#4514',
    channel: 'Collina.rs',
    location: 'Vračar',
    done: '6:20',
    est: '7 min',
    estAccurate: true,
    wait: '1:15'
  }, {
    id: '#4513',
    channel: 'Wolt',
    location: 'Vračar',
    done: '11:30',
    est: '8 min',
    estAccurate: false,
    wait: '0:45'
  }]
};
function CapacityBar() {
  return <Card className="mb-6 bg-background-elevated/50 border-white/5" data-id="element-2602">
      <div className="flex justify-between items-center mb-4" data-id="element-2603">
        <div className="flex items-center gap-2" data-id="element-2604">
          <span className="text-lg" data-id="element-2605">📊</span>
          <h3 className="font-bold text-sm uppercase tracking-wider" data-id="element-2606">
            Current Capacity
          </h3>
        </div>
        <div className="flex items-center gap-3 text-xs" data-id="element-2607">
          <span className="flex items-center gap-1.5 text-accent-success font-medium" data-id="element-2608">
            <span className="w-2 h-2 rounded-full bg-accent-success animate-pulse" data-id="element-2609"></span>{' '}
            Live
          </span>
          <span className="text-text-secondary" data-id="element-2610">Updated: now</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-4" data-id="element-2611">
        {STATIONS.map(station => <div key={station.name} data-id="element-2612">
            <div className="flex justify-between text-xs mb-1.5" data-id="element-2613">
              <span className="font-medium flex items-center gap-1" data-id="element-2614">
                {station.icon} {station.name}
              </span>
              <span className={`font-bold ${station.warning ? 'text-accent-warning' : 'text-text-secondary'}`} data-id="element-2615">
                {station.load}% {station.warning && '⚠️'}
              </span>
            </div>
            <div className="h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-2616">
              <div className={`h-full rounded-full transition-all duration-500 ${station.color}`} style={{
            width: `${station.load}%`
          }} data-id="element-2617"></div>
            </div>
          </div>)}
      </div>

      <div className="flex items-center gap-2 text-sm text-text-secondary pt-3 border-t border-white/5" data-id="element-2618">
        <span className="text-lg" data-id="element-2619">🤖</span>
        <span data-id="element-2620">
          Est. wait for new orders:{' '}
          <span className="font-bold text-text-primary" data-id="element-2621">~12 min</span>
        </span>
      </div>
    </Card>;
}
function OrderCard({
  order,
  type
}: {
  order: any;
  type: 'new' | 'progress' | 'ready';
}) {
  const channelColor = order.channel === 'Wolt' ? 'text-blue-400 bg-blue-400/10' : 'text-green-400 bg-green-400/10';
  return <Card className="p-4 hover:border-white/20 transition-colors cursor-pointer group" data-id="element-2622">
      <div className="flex justify-between items-start mb-3" data-id="element-2623">
        <div data-id="element-2624">
          <div className="flex items-center gap-2 mb-1" data-id="element-2625">
            <span className="font-bold text-lg" data-id="element-2626">{order.id}</span>
            <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${channelColor}`} data-id="element-2627">
              {order.channel}
            </span>
          </div>
          <div className="text-xs text-text-secondary flex items-center gap-1" data-id="element-2628">
            <span className="text-accent-primary" data-id="element-2629">📍</span> {order.location}
            {order.time && <span className="text-text-muted ml-1" data-id="element-2630">{order.time}</span>}
          </div>
        </div>
      </div>

      {type === 'new' && <>
          <div className="space-y-1 mb-3" data-id="element-2631">
            {order.items.map((item: string, i: number) => <div key={i} className="text-sm font-medium" data-id="element-2632">
                {item}
              </div>)}
          </div>

          <div className="flex flex-wrap gap-2 mb-3" data-id="element-2633">
            {order.stations.map((st: string, i: number) => <span key={i} className="text-[10px] font-bold px-2 py-1 rounded bg-white/10 text-text-secondary" data-id="element-2634">
                {st === 'Burgeri' ? '🍔 Burgeri' : st === 'Pack' ? '📦 Pack' : st === 'Palačinke' ? '🥞 Palačinke' : st}
              </span>)}
          </div>

          <div className="flex items-center justify-between pt-3 border-t border-white/5" data-id="element-2635">
            <div className="flex items-center gap-1.5 text-xs text-text-secondary" data-id="element-2636">
              <span data-id="element-2637">🤖</span> Est:{' '}
              <span className="font-bold text-text-primary" data-id="element-2638">{order.est}</span>
            </div>
          </div>

          {order.comment && <div className="mt-3 p-2 bg-accent-warning/10 rounded text-xs text-accent-warning flex gap-2" data-id="element-2639">
              <MessageSquare size={14} className="shrink-0 mt-0.5" data-id="element-2640" />"
              {order.comment}"
            </div>}
        </>}

      {type === 'progress' && <>
          <div className="mb-3" data-id="element-2641">
            <div className="flex items-center gap-2 mb-1" data-id="element-2642">
              <Clock size={14} className={order.status === 'good' ? 'text-accent-success' : order.status === 'warning' ? 'text-accent-warning' : 'text-accent-error'} data-id="element-2643" />
              <span className="text-sm font-mono font-bold" data-id="element-2644">
                {order.actual}{' '}
                <span className="text-text-muted font-normal" data-id="element-2645">
                  / {order.est}
                </span>
              </span>
              <div className={`w-2 h-2 rounded-full ${order.status === 'good' ? 'bg-accent-success' : order.status === 'warning' ? 'bg-accent-warning' : 'bg-accent-error'}`} data-id="element-2646"></div>
            </div>
          </div>

          <div className="space-y-1 mb-3" data-id="element-2647">
            {order.items.map((item: string, i: number) => <div key={i} className="text-sm font-medium text-text-secondary" data-id="element-2648">
                {item}
              </div>)}
          </div>

          <div className="text-xs text-text-muted pt-2 border-t border-white/5" data-id="element-2649">
            {order.stations[0]}
          </div>
        </>}

      {type === 'ready' && <>
          <div className="space-y-2 mb-3" data-id="element-2650">
            <div className="flex items-center gap-2 text-sm text-accent-success" data-id="element-2651">
              <Check size={14} data-id="element-2652" />
              <span data-id="element-2653">Done in {order.done}</span>
            </div>
            <div className="flex items-center gap-2 text-xs text-text-secondary" data-id="element-2654">
              <span data-id="element-2655">🤖</span>
              <span data-id="element-2656">Est: {order.est}</span>
              {order.estAccurate ? <Check size={12} className="text-accent-success" data-id="element-2657" /> : <AlertTriangle size={12} className="text-accent-warning" data-id="element-2658" />}
            </div>
          </div>

          <div className="pt-3 border-t border-white/5 flex items-center gap-2 text-xs font-medium text-text-primary" data-id="element-2659">
            {order.channel === 'Wolt' ? '🚴' : '📞'} Waiting {order.wait}
          </div>
        </>}
    </Card>;
}
export function LiveQueue() {
  return <div className="space-y-6 animate-in fade-in duration-500 h-[calc(100vh-100px)] flex flex-col" data-id="element-2660">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 shrink-0" data-id="element-2661">
        <div data-id="element-2662">
          <h1 className="text-2xl font-bold text-text-primary flex items-center gap-3" data-id="element-2663">
            Orders{' '}
            <span className="text-lg font-normal text-text-secondary" data-id="element-2664">
              127 today · 23 active
            </span>
          </h1>
        </div>
        <div className="flex items-center gap-3" data-id="element-2665">
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-2666">
            All Locations <ChevronDown size={14} data-id="element-2667" />
          </button>
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-2668">
            All Channels <ChevronDown size={14} data-id="element-2669" />
          </button>
          <div className="relative" data-id="element-2670">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary" data-id="element-2671" />
            <input type="text" placeholder="Search #" className="bg-background-elevated border border-white/10 rounded-lg pl-9 pr-4 py-2 text-sm focus:outline-none focus:border-accent-primary w-32" data-id="element-2672" />
          </div>
        </div>
      </div>

      <div className="shrink-0" data-id="element-2673">
        <TabNavigation tabs={ORDER_TABS} basePath="/orders" data-id="element-2674" />
        <CapacityBar data-id="element-2675" />
      </div>

      {/* Kanban Board */}
      <div className="flex-1 min-h-0 overflow-x-auto pb-4" data-id="element-2676">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 min-w-[900px] h-full" data-id="element-2677">
          {/* New Column */}
          <div className="flex flex-col h-full bg-background-elevated/20 rounded-xl p-4 border border-white/5" data-id="element-2678">
            <div className="flex justify-between items-center mb-4 shrink-0" data-id="element-2679">
              <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm" data-id="element-2680">
                New ({ORDERS.new.length})
              </h3>
            </div>
            <div className="space-y-3 overflow-y-auto pr-2 flex-1" data-id="element-2681">
              {ORDERS.new.map(order => <OrderCard key={order.id} order={order} type="new" data-id="element-2682" />)}
            </div>
          </div>

          {/* In Progress Column */}
          <div className="flex flex-col h-full bg-background-elevated/20 rounded-xl p-4 border border-white/5" data-id="element-2683">
            <div className="flex justify-between items-center mb-4 shrink-0" data-id="element-2684">
              <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm" data-id="element-2685">
                In Progress ({ORDERS.progress.length})
              </h3>
            </div>
            <div className="space-y-3 overflow-y-auto pr-2 flex-1" data-id="element-2686">
              {ORDERS.progress.map(order => <OrderCard key={order.id} order={order} type="progress" data-id="element-2687" />)}
            </div>
          </div>

          {/* Ready Column */}
          <div className="flex flex-col h-full bg-background-elevated/20 rounded-xl p-4 border border-white/5" data-id="element-2688">
            <div className="flex justify-between items-center mb-4 shrink-0" data-id="element-2689">
              <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm" data-id="element-2690">
                Ready for Pickup ({ORDERS.ready.length})
              </h3>
            </div>
            <div className="space-y-3 overflow-y-auto pr-2 flex-1" data-id="element-2691">
              {ORDERS.ready.map(order => <OrderCard key={order.id} order={order} type="ready" data-id="element-2692" />)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}